import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from "axios";
import {ChineseText} from "./variables/ChineseText"
import {EnglishText} from "./variables/EnglishText"
import {ChineseText as TaskChineseText} from "./pages/services/tasks/variables/ChineseText"
import {EnglishText as TaskEnglishText} from "./pages/services/tasks/variables/EnglishText"

export const getTexts = () => {
    const lang = localStorage.getItem("lang") || "cn";
    return lang === "en"
        ? { ...EnglishText, ...TaskEnglishText }
        : { ...ChineseText, ...TaskChineseText };
};

// Set base URL from environment variable
axios.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT;
axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App/>
);

reportWebVitals();
